import { render, staticRenderFns } from "./drawer-inner.vue?vue&type=template&id=07fc974e&"
import script from "./drawer-inner.vue?vue&type=script&lang=js&"
export * from "./drawer-inner.vue?vue&type=script&lang=js&"
import style0 from "./drawer-inner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fc974e')) {
      api.createRecord('07fc974e', component.options)
    } else {
      api.reload('07fc974e', component.options)
    }
    module.hot.accept("./drawer-inner.vue?vue&type=template&id=07fc974e&", function () {
      api.rerender('07fc974e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/drawer-panel/drawer-inner.vue"
export default component.exports